import { useNavigate } from "react-router-dom";

import useLoginCookie from "shared/model/useLoginCookie";
import useRoleCookie from "shared/model/useRoleCookie";
import useNameCookie from "shared/model/useNameCookie";
import useConfirmModalAtom from "shared/model/useConfirmModalAtom";

const useLogoutEvent = () => {
  const navigate = useNavigate();

  const [, , deleteLoginCookie] = useLoginCookie();
  const [, , deleteRoleCookie] = useRoleCookie();
  const [, , deleteNameCookie] = useNameCookie();
  const [, setConfirmModal] = useConfirmModalAtom();

  const logout = () => {
    deleteLoginCookie();
    deleteRoleCookie();
    deleteNameCookie();
    navigate("/");
  };

  const logoutModelEvent = () => {
    setConfirmModal("로그아웃 할까요?", () => logout);
  };

  return [logoutModelEvent, logout];
};

export default useLogoutEvent;
